import Templates from 'Modules/contacard/communication/templates/routes';
import UsageReport from 'Modules/contacard/communication/usage-report/routes';
import Notifications from 'Modules/contacard/communication/notifications/routes';
import { buildSubModuleRoute } from 'Arch/helpers/RouterHelper';

export default [
  buildSubModuleRoute({
    moduleId: 'contacard',
    name: 'communication',
    path: 'communication/',
    subModuleTitle: 'Comunicação',
    subModuleGroup: [
      {
        title: 'Notificações',
        name: 'notification',
      },
    ],
    children: [...Templates, ...UsageReport, ...Notifications],
  }),
];
